.viewport {
  height: 100%;
}

.container {
  height: 100%;
}

.indicators {
  top: 32px;
  bottom: unset;
}

.indicator {
  width: 8px;
  height: 8px;
  opacity: 1;
  background: var(--mantine-color-brand-1);
}

.indicator[data-active] {
  background: var(--mantine-color-brand-7);
}
